import { ContentTypes, ForbiddenError, HttpStatusCodes, Inject, Result, ServerSentEvent } from '@resourceful-hono/core';
import { Permissions } from '../../../services/OAuth/enums.ts';
import { BaseResource } from '../BaseResource.ts';
import { Protected } from '../common/decorators.ts';
import { Game } from '../../../entities/Game.ts';
import { EventService } from '../../../services/Events.ts';

export class EventsResource extends BaseResource {
  @Inject()
  declare private readonly events: EventService;

  @Protected([Permissions.GetGame])
  public async GET() {
    const { id: gameId } = await this.game ?? {};
    if (!gameId)
      throw new ForbiddenError('You need to be in a game.');
    return Result(
      HttpStatusCodes.Ok,
      this.sendEvents.bind(this, gameId),
      ContentTypes.ServerSentEvent
    );
  }

  private get game() {
    return Game.findOne({
      where: {
        players: {
          id: this.userId,
        },
      },
    });
  }

  private async *sendEvents(gameId: number) {
    const signal = this.request.signal;
    const stream = this.events.stream('game-event');
    for await (const event of stream) {
      if (signal.aborted) break;
      if (event.gameId === gameId) {
        if (event.userId && event.userId !== this.userId)
          continue;
        yield new ServerSentEvent('invalidation', {
          id: event.gameId,
          data: event.target,
        });
      }
    }

    stream.cancel(signal.reason);
  }
}